import { render, staticRenderFns } from "./MobileSettings.vue?vue&type=template&id=055a530e&scoped=true"
import script from "./MobileSettings.vue?vue&type=script&lang=js"
export * from "./MobileSettings.vue?vue&type=script&lang=js"
import style0 from "./MobileSettings.vue?vue&type=style&index=0&id=055a530e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055a530e",
  null
  
)

export default component.exports